import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGb = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 60 30",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("clipPath", {
			id: "t",
			children: /* @__PURE__ */ _jsx("path", { d: "M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z" })
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0,0 v30 h60 v-30 z",
			fill: "#00247d"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0,0 L60,30 M60,0 L0,30",
			stroke: "#fff",
			strokeWidth: 6
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0,0 L60,30 M60,0 L0,30",
			clipPath: "url(#t)",
			stroke: "#cf142b",
			strokeWidth: 4
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30,0 v30 M0,15 h60",
			stroke: "#fff",
			strokeWidth: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30,0 v30 M0,15 h60",
			stroke: "#cf142b",
			strokeWidth: 6
		})
	]
});
export default SvgGb;
